export default __webpack_public_path__ + "static/media/search.feee0b46.svg";